(function() {
  const triggers = document.querySelectorAll('.fw-megamenu-trigger');

  function getHeaderBottom() {
    const sectionHeader = document.querySelector('.shopify-section-header, .section-header');
    if (sectionHeader) return Math.round(sectionHeader.getBoundingClientRect().bottom);
    const header = document.querySelector('header.header, .header');
    if (header) return Math.round(header.getBoundingClientRect().bottom);
    return 94;
  }

  function closeAll() {
    triggers.forEach(t => {
      const btn = t.querySelector('.fw-megamenu-btn');
      const menu = t.querySelector('.fw-megamenu');
      if (menu) menu.setAttribute('aria-hidden', 'true');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      t.classList.remove('fw-megamenu-open');
    });
  }

  triggers.forEach(trigger => {
    const btn = trigger.querySelector('.fw-megamenu-btn');
    const menu = trigger.querySelector('.fw-megamenu');
    if (!btn || !menu) return;

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = trigger.classList.contains('fw-megamenu-open');
      closeAll();
      if (!isOpen) {
        menu.style.top = getHeaderBottom() + 'px';
        menu.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        trigger.classList.add('fw-megamenu-open');
      }
    });
  });

  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
})();
